import { EntryTypeFavoriteDataParams, FavoriteData } from 'chaika-frontend-types/frontend-cms';

import { SimpleList } from '@store/models/SimpleList';

export class EntryTypeFavoriteList extends SimpleList<FavoriteData<EntryTypeFavoriteDataParams>> {
    public getMostRecentEntryTypeRecord() {
        const favorites = this.values;
        return favorites.length > 0 ? favorites[favorites.length - 1] : null;
    }
}
